export const constructItemNavigationUrl = ({
  itemId,
  ledgerId,
  type,
}: {
  itemId: number | string | null | undefined
  ledgerId: number
  type: string | undefined
}): string => {
  if (!itemId || !ledgerId || !type) {
    return ''
  }
  const { Routes, currentFirmId, currentCompanyId } = window.Silverfin

  if (type === 'account_entry') {
    return Routes.ledger_account_entry_path({
      firm_id: currentFirmId,
      company_id: currentCompanyId,
      ledger_id: ledgerId,
      current_ledger_id: ledgerId,
      account_number: itemId,
    })
  } else if (type === 'reconciliation_text') {
    return Routes.ledger_reconciliation_text_path({
      firm_id: currentFirmId,
      company_id: currentCompanyId,
      id: itemId,
      ledger_id: ledgerId,
      _options: true,
    })
  }

  return ''
}
